import { render, staticRenderFns } from "./EventFormActivitySelector.vue?vue&type=template&id=2047a7fc&scoped=true&"
import script from "./EventFormActivitySelector.vue?vue&type=script&lang=js&"
export * from "./EventFormActivitySelector.vue?vue&type=script&lang=js&"
import style0 from "./EventFormActivitySelector.vue?vue&type=style&index=0&id=2047a7fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047a7fc",
  null
  
)

export default component.exports